import React, {useState} from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import _ from 'lodash'
import Badge from 'react-bootstrap/Badge'
import db from '../firebase'

const PostSnippet = (props) => {

    const [status, setStatus] = useState(props.doc.currentstatus)
    const [variant, setVariant] = useState(props.doc.variant? props.doc.variant : 'danger')
    
    const onStatusChange = (x) =>{setStatus(x)}
    
    const submitChanges = (x) =>{
        let postdef = db.collection('servicerequests').doc(props.doc.id)
        let payload = {}
        payload.variant = x.new_v
        payload.currentstatus = x.new_s
        console.log(payload)
        // postdef.update(payload)
        //      .then(function(doc) {
        //         console.log("Document Uploaded successfully!", doc.id)
        //     })
    }
    
    const onTechnicianSent = () =>{
        onStatusChange('Technician Sent')
        setVariant('primary')
        let new_s = 'Technician Sent'
        let new_v = 'primary'
        let x = { new_s, new_v}
        submitChanges(x)
    }

    return(
        <div className="post_snippet_outer_container my-2">
            <div className="post_snippet_inner">
                <Card>
                    <Card.Header as="h4">Category : {props.doc.device}<Badge className="mx-md-1 mx-lg-3"  variant={variant}>{status} </Badge></Card.Header>
                    <Card.Body>
                        <Card.Text>
                                Name : {props.doc.firstname} {props.doc.middlename} {props.doc.lastname}  
                            <br />
                                Phone : {props.doc.phone}   Alternate Phone : {props.doc.altphone}     Email : {props.doc.email}
                            <br />
                                Device : {props.doc.company} {props.doc.model}  ({props.doc.device})
                            <br />
                                Problem : {props.doc.problem} 
                            <br/>
                                Address: {props.doc.address} 
                            <br />                            
                                State : {props.doc.state}  City: {props.doc.city}  Pin code : {props.doc.pincode}
                        </Card.Text> 
                        <Button onClick={onTechnicianSent} variant="outline-primary">Technician Sent</Button>
                        <Button   variant="outline-primary" className="m-3">Issue Solved</Button>
                        <Button   variant="outline-primary">Unrepairable</Button>
                    </Card.Body>
                    
                </Card>
            </div>
        </div>
    )
}

export default PostSnippet;